import React, { useState, useEffect } from 'react';
import { Form, Modal } from 'semantic-ui-react';
import { AddProject } from '../providers/HomeProvider';
import { copyObject } from '../utility';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { FlexRow } from '../layouts';

export interface IAddProjectModal {
  open: boolean;
  initialValues: AddProject;

  onSubmit(_values: AddProject): void;
  onCancel(): void;
}

const AddProjectModal = (props: IAddProjectModal) => {
  const { initialValues, open, onSubmit, onCancel } = props;
  const [values, setValues] = useState<AddProject>();

  const { t } = useTranslation();

  useEffect(() => {
    setValues(initialValues);
  }, [initialValues]);

  const handleChange = (_e: any, data: any) => {
    let copy = copyObject(values);
    copy[data.name] = data.value;
    setValues(copy);
  };
  return (
    <Modal open={open} as={Form}>
      {values && (
        <>
        <Modal.Header>{values.id? t('home.editProject') : t('home.addNewProject')}</Modal.Header>
        <Modal.Content>
          <Form.Input
            name="en_project_name"
            label={t('home.projectNameEN')}
            value={values.en_project_name}
            onChange={handleChange}
          />
          <Form.Input
            name="fr_project_name"
            label={t('home.projectNameFR')}
            value={values.fr_project_name}
            onChange={handleChange}
          />
          <Form.TextArea
            name="en_project_description"
            label={t('home.projectDescriptionEN')}
            value={values.en_project_description}
            onChange={handleChange}
          />
          <Form.TextArea
            name="fr_project_description"
            label={t('home.projectDescriptionFR')}
            value={values.fr_project_description}
            onChange={handleChange}
          />
          <FlexRow fullWidth right>
            <Form.Button onClick={onCancel} color="grey">
              {t('general.cancel')}
            </Form.Button>
            <Form.Button onClick={() => onSubmit(values)} color="green">
              {t('general.save')}
            </Form.Button>
          </FlexRow>
        </Modal.Content>
        </>
      )}
    </Modal>
  );
};

export default AddProjectModal;
